// extracted by mini-css-extract-plugin
export default {"root":"_3RhgY","favoriteIconActive":"_24z_h"};